import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';

import t from '../../lib/I18n';
import Checkbox from '../form/Checkbox';

const AddJourneyModalUsualDays = ({ businessDays, setBusinessDays }) => {
    const checkDays = id => {
        const updatedDays = businessDays.map(day => (day.id === id ? { ...day, checked: !day.checked } : day));

        setBusinessDays(updatedDays);
    };

    return (
        <Row className="margin-left--xs margin-right--xs margin-bottom--sm margin-top--sm">
            <Col xs={12} className="journey-modal-usually-title">
                {t('auto-dr.account.subscribe.journeys.modal.usually')}
            </Col>
            <Col xs={12} className="journey-modal-usually-days margin-top--sm">
                {businessDays.map(({ day, checked, id }) => (
                    <Checkbox
                        key={day}
                        className="journey-modal-days-checkbox"
                        label={day[0].toUpperCase() + day.slice(1)}
                        aria-label={day}
                        onChange={() => checkDays(id)}
                        checked={checked}
                    />
                ))}
            </Col>
        </Row>
    );
};

AddJourneyModalUsualDays.propTypes = {
    businessDays: PropTypes.array,
    setBusinessDays: PropTypes.func,
};

export default AddJourneyModalUsualDays;
